module.exports = ".footer_links{\n    padding: 15px;\n    text-align: center;\n    position: absolute;    \n    bottom: 0;\n    width: 100%;\n}\n.footer_links p{\n    display: inline;\n    padding: 20px;\n}\n.footer_links a{\n    color: #000;\n    text-transform: uppercase;\n    text-decoration: none;\n}\n.footer_links a:hover{\n    text-decoration: underline\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.css
// module id = ./src/app/footer/footer.component.css
// module chunks = main